import type { RouteChainOf } from '@luminovo/design-system';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { AppProviders } from '@/app/AppProviders';
import { AppWithAuth } from '@/app/AppWithAuth';
import type { RouterAuth } from '@/app/routerAuth';
import { RootErrorComponent } from '@/app/routerDefaults';
import type { PageStaticData } from '@/shared/routing';

// Not the default error component: its `ErrorFallback` and `NotAuthorizedPage` need a token `_authenticated` fetches.
export const Route = createRootRouteWithContext<{
    queryClient: QueryClient;
    auth: RouterAuth;
    // `createAppRouter` adds it, so a `beforeLoad` can ask what the page a link opens requires.
    routeChainOf: RouteChainOf;
}>()({
    staticData: { access: 'public', chrome: 'none' } satisfies PageStaticData,
    component: RootComponent,
    errorComponent: RootErrorComponent,
});

function RootComponent(): JSX.Element {
    return (
        <AppProviders>
            <AppWithAuth>
                <Outlet />
            </AppWithAuth>
        </AppProviders>
    );
}
